import { Button, Container, Form, Table, Modal } from 'react-bootstrap';
import { GoDiffAdded, GoTrashcan } from 'react-icons/go';

import styles from './Suprimentos.module.css';

const Suprimentos = props => {
  function formatInsumoDescricao(insumo) {
    return [
      insumo?.descricao,
      insumo?.apresentacao,
      insumo?.qtdApresentacao
    ].filter(Boolean).join(' / ');
  }

  function selecionarInsumo(index, insumo) {
    props.handleSuprimentoSelecionado(index, {
      tipoInsumo: insumo?.tipoInsumo ?? '',
      codigoInterno: insumo?.codigoInterno !== undefined && insumo?.codigoInterno !== null ? String(insumo.codigoInterno) : '',
      descricao: insumo?.descricao ?? '',
      apresentacao: insumo?.apresentacao ?? '',
      qtdApresentacao: insumo?.qtdApresentacao ?? ''
    });
  }

  function handleDescricaoChange(index, codigoInterno) {
    const insumo = props.getListaSuprimentosByTipo(props.suprimentos[index].tipoInsumo)
      .find(item => String(item.codigoInterno) === codigoInterno);

    selecionarInsumo(index, {
      ...insumo,
      tipoInsumo: props.suprimentos[index].tipoInsumo,
      codigoInterno
    });
  }

  function handleTipoInsumoChange(index, tipoInsumo) {
    props.handleTipoInsumo(index, tipoInsumo);
  }

  return (
    <Container className={styles.container_suprimentos}>
      <Table responsive striped bordered hover variant="dark">
        <thead>
          <tr>
            <th style={{ width: '25%' }}>Tipo de Insumo</th>
            <th>Descrição / Apresentação / Quantidade do Insumo</th>
            <th style={{ width: '10%' }}>Qtd</th>
            <th style={{ width: '20%' }}>Ação</th>
          </tr>
        </thead>

        <tbody>
          {props.suprimentos.map((item, index) => {
            return (
              <tr key={`${item.nome}-${index}`}>
                <td>
                  <Form.Group controlId="tipoInsumo">
                    <Form.Select
                      required
                      name="tipoInsumo"
                      onChange={e => handleTipoInsumoChange(index, e.target.value)}
                      value={props.suprimentos[index].tipoInsumo}
                    >
                      <option value=""></option>
                      {props.tipoInsumoSelect.map(item => (
                        <option key={item} value={item}>{item}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="descricao">
                    <Form.Select
                      required
                      name="descricao"
                      onChange={e => handleDescricaoChange(index, e.target.value)}
                      value={props.suprimentos[index].codigoInterno}
                      disabled={props.getListaSuprimentosByTipo(props.suprimentos[index].tipoInsumo).length === 0}
                    >
                      <option value=""></option>
                      {props.getListaSuprimentosByTipo(props.suprimentos[index].tipoInsumo).map(item => (
                        <option key={item.codigoInterno} value={item.codigoInterno}>
                          {formatInsumoDescricao(item)}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="quantidade">
                    <Form.Control
                      autoComplete="new-off"
                      required
                      type="number"
                      step="1"
                      name="quantidade"
                      onChange={e => props.handleSuprimentos(index, 'quantidade', e.target.value)}
                      value={props.suprimentos[index].quantidade}
                    />
                  </Form.Group>
                </td>
                <td>
                  <div className={styles.container_buttons}>
                    <Button
                      variant="warning"
                      id="deleteTableRow"
                      onClick={e => props.handleRemoveSuprimentos(index)}
                      disabled={index === 0 && props.suprimentos.length === 1}
                    >
                      <div className={styles.icon_container}>
                        <GoTrashcan className={styles.icon_trash} />Excluir
                      </div>
                    </Button>

                    <Button
                      variant="flat" className={styles.btn}
                      id="addTableRow"
                      onClick={props.handleAddSuprimentos}
                    >
                      <div className={styles.icon_container}>
                        <GoDiffAdded className={styles.icon_trash} />Incluir
                      </div>
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      
      <Modal show={props.showModal} onHide={props.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.suprimentoError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default Suprimentos;
